import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M23.5,0h-1a.48.48,0,0,0-.43.25L17.91,7.32a.5.5,0,0,0,.08.61l3.92,3.92a.49.49,0,0,0,.66,0l1.24-1A.49.49,0,0,0,24,10.5V.5A.5.5,0,0,0,23.5,0Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M16.87,8.93a.5.5,0,0,0-.49-.13l-2.9.83a2.5,2.5,0,0,0-1.72,1.72l-2.27,8a.07.07,0,0,0,0,.08.06.06,0,0,0,.08,0l5.63-5.63a.75.75,0,0,1,1.06,0,.74.74,0,0,1,0,1.06l-5.63,5.63a.08.08,0,0,0,0,.08.11.11,0,0,0,.07,0l8-2.28a2.48,2.48,0,0,0,1.72-1.73l.78-2.94a.52.52,0,0,0-.13-.48Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M8.3,21.28A3.43,3.43,0,0,1,6,22a3.21,3.21,0,0,1-2.65-1c-.63-1-.44-2.72.57-5.06,2-4.71,4.13-8.44,2.8-11.62C6,2.5,4.26,1.16,1.35.06a1,1,0,0,0-.7,1.88C3,2.81,4.36,3.83,4.87,5.05c1,2.28-.9,5.65-2.79,10.06-1.3,3-1.43,5.37-.39,7A5,5,0,0,0,6,24a5.31,5.31,0,0,0,3.7-1.29,1,1,0,0,0,0-1.4A1,1,0,0,0,8.3,21.28Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }